import { render, staticRenderFns } from "./DatavizPie.vue?vue&type=template&id=d91f4100&"
import script from "./DatavizPie.vue?vue&type=script&lang=js&"
export * from "./DatavizPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports